module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_017.png
// module id = 2364
// module chunks = 5